<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <el-menu :default-active="idx" class="el-menu-demo" mode="horizontal">
                <el-menu-item index="0" @click="$router.push('live')">智慧住建</el-menu-item>
                <el-menu-item index="1" @click="$router.push('site')">智慧工地</el-menu-item>
                <el-menu-item index="2" @click="$router.push('schemeSafety')">智慧安全</el-menu-item>
                <el-menu-item index="3" @click="$router.push('schemeCartoon')">工程动画</el-menu-item>
                <el-menu-item index="4" @click="$router.push('schemeShowRoom')">项目展厅展馆</el-menu-item>
            </el-menu>
        </div>
        <div class="box3">
            <div class="main" v-for="item in dataList" :key="item.id" @click="siteClick(item.id)">
                <img class="lef" :src="item.img">
                <div>
                    <p class="tit">{{ item.title }}</p>
                    <p class="txt">{{ item.text }}</p>
                </div>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Site",
    data() {
        return {
            idx: '0',
            dataList: [
                {
                    id: 0,
                    img: require('./img/live/1.jpg'),
                    title: '智慧住建管理平台',
                    text: '智慧住建管理平台，重在强化信息管理、提升服务水平，搭建“一平台、两体系、三系统、四库”总体框架，以智慧统筹住房城乡建设发展，推进基础设施智能化、行业管理精细化、公共服务便捷化、办公系统自动化，实现“监管职能的再监督，服务水平的再提升。'
                },
            ]
        }
    },
    methods: {
        siteClick(id) {
            this.$router.push({
                path: 'liveDetail', query: {
                    index: id
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    height: 2.9rem;
    width: 100%;
    background: url("./img/banner/5.png");
    background-size: 100% 100%;
}

.box2 {
    width: 10rem;
    margin: .34rem auto .6rem;
    text-align: center;

    a {
        text-decoration: none;
    }

    .el-menu-item {
        width: 2rem;
        font-size: .2rem;
        height: .72rem;
        line-height: .72rem;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: 3px solid #E70F20;
        color: #E70F20;
    }

    .el-menu--horizontal > .el-menu-item {
        color: #000;
    }
}

.box3 {
    width: 12rem;
    margin: 0 auto;

    .main {
        cursor: pointer;
        height: 2.2rem;
        background: #FBFBFB;
        display: flex;
        position: relative;
        margin-bottom: .3rem;

        img.lef {
            width: 3.6rem;
            height: 2.2rem;
        }

        div {
            height: 1.6rem;
            margin: .3rem 0 0 .57rem;

            p.tit {
                font-size: .26rem;
            }

            p.txt {
                width: 6.5rem;
                font-size: .18rem;
                color: #595757;
                line-height: .36rem;
                text-align: justify;
                margin-top: .23rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }

        span {
            position: absolute;
            width: .38rem;
            height: .38rem;
            background: url("../../assets/images/more.png");
            background-size: 100% 100%;
            right: .32rem;
            bottom: .35rem;
            cursor: pointer;
        }
    }
}
</style>
